import moment from "moment";
import { useState, useEffect } from "react";
import {
  Button,
  Col,
  FormControl,
  InputGroup,
  Modal,
  Row,
  Tab,
  Table,
  Tabs,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import { withTranslation } from "react-i18next";
import { FaPlus, FaTimes } from "react-icons/fa";
import { IoMdStats } from "react-icons/io";
import Get from "../../api/Get";
import Post from "../../api/Post";
import Put from "../../api/Put";
import {
  GET_EFERMEDADES,
  GET_EXPEDIENTE_CLINICO_BY_APPOINTMENT,
  GET_FAMILIAR,
  GET_MASCOTAS,
  GET_TIPO_FAILIAR,
  REPORT_DOCUMENT_PATIENT,
  REPORT_HISTORIC_DATA,
  REPORT_MEDICAMENTOS,
  RESPORT_HISTORIC_EXP,
  SAVE_EXPEDIENTE_CLINICO,
  UPDATE_EXPEDIENTE_CLINICO,
} from "../../api/Routes";
import SimpleLoad from "../../loader/SimpleLoad";
import HistoricExpC from "./HistoricExpC";
import HistoricExpCLab from "./HistoricExpCLab";
import HistoricExpCMedicamentos from "./HistoricExpCMedicamentos";
import GinecoObstetricoMex from "./expedienteClinicoMx/GinecoObstetricoMex";
import HealthyChildMex from "./expedienteClinicoMx/HealthyChildMex";
import GerontologicalMex from "./expedienteClinicoMx/Gerontological";
import HealthPromotion from "./expedienteClinicoMx/HealthPromotion";
import AccidentPrevention from "./expedienteClinicoMx/AccidentPrevention";
import AntPersPatologicos from "./expedienteClinicoMx/AntPersPatologicos";
import { pad } from "lodash";



const hideSaveDefault = (key) => {
  const arraykeys = ["ginecoObstretico", "ninoSano", "gerontological", "healthpromotion", "accidentprevention", "antperspatologicos"];
  return !arraykeys.includes(key);
};

function ExpedienteClinicoMex({
  t,
  cita,
  auth,
  setShowModalServer,
  setErrorServer,
  setShowSuccess,
  readOnly,
}) {
  const [showModal, setShowModal] = useState(false);
  const [isSubmiting, setSubmiting] = useState(false);
  const [antecedentesHF, setAntecedentesHF] = useState([]);
  const [reload, setReload] = useState(true);
  const [id, setId] = useState(null);
  const [errors, setErrors] = useState({});

  const [antecedentesNP, setAntecedentesNP] = useState({
    id: null,
    mascotas: "",
    servicios: "",
    tipoPiso: "",
    viveCon: "",
  });

  const [antecedentesPatologicos, setAntecedentesPatologicos] = useState([]);

  const [padecimientoActual, setPadecimientoActual] = useState({
    id: null,
    fechaHora: new Date(),
    temperatura: "",
    frecuenciaCardiaca: "",
    frecuenciaRespiratoria: "",
    frecuenciaSaturacionOxigeno: "",
    perimetroCefalico: "",
    peso: "",
    estatura: "",
    indiceMasaCorporal: "",
    glucosaEnSangre: "",
    tipoMedicion: -1,
    presionSistolica: "",
    presionDiastolica: "",
    glasgow: "",
    circunferenciaCintura: 0,
    primeraVezAnio: 0,
    primeraVezUnemeSaih: "-1",
    tipoDificultad: "-1",
    gradoDificultad: "-1",
    origenDificultad: "-1",
    numeroTirasControlUtilizadas: "",
    relacionTemporal: 0,
  });

  //nomelcadores
  const [tipoFamiliarOpt, setTipoFamiliarOpt] = useState([]);
  const [mascotasOpt, setMascotasOpt] = useState([]);
  const [familiarOpt, setFamiliarOpt] = useState([]);
  const [enfermedadOpt, setEnfermedadOpt] = useState([]);

  const [key, setKey] = useState("antecedentesHF");

  useEffect(() => {
    Get({ url: GET_TIPO_FAILIAR, access_token: auth.data.access_token })
      .then((response) => {
        setTipoFamiliarOpt(response.data.data.response);
      })
      .catch((error) => {
        setShowModalServer(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({ url: GET_MASCOTAS, access_token: auth.data.access_token })
      .then((response) => {
        setMascotasOpt(response.data.data.response);
      })
      .catch((error) => {
        setShowModalServer(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({ url: GET_FAMILIAR, access_token: auth.data.access_token })
      .then((response) => {
        setFamiliarOpt(response.data.data.response);
      })
      .catch((error) => {
        setShowModalServer(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
    Get({ url: GET_EFERMEDADES, access_token: auth.data.access_token })
      .then((response) => {
        setEnfermedadOpt(response.data.data.response);
      })
      .catch((error) => {
        setShowModalServer(true);
        if (error.response) {
          setErrorServer(error.response);
        }
      });
  }, []);

  //efecto para obtener el expediente clinico
  useEffect(() => {
    if (reload) {
      Get({
        url: `${GET_EXPEDIENTE_CLINICO_BY_APPOINTMENT}/${cita.id}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          //console.log(response)
          if (response.data.data) {
            setId(response.data.data.id);
            //antHF
            let antHF = response.data.data.antecedentesFamiliares.map(
              (item) => ({
                ...item,
                tipoFamiliar: item.tipoFamiliar ? item.tipoFamiliar.id : "",
              })
            );
            setAntecedentesHF(antHF);

            //antP
            let antP = response.data.data.antecedentesPatologicos.map(
              (item) => ({
                ...item,
                enfermedad: item.enfermedad ? item.enfermedad.id : "",
                meses: item.meses === null ? "" : item.meses,
                anios: item.anios === null ? "" : item.anios,
              })
            );
            setAntecedentesPatologicos(antP);

            //antNP
            let antNP = Object.assign(
              {},
              response.data.data.antecedentesNoPatologicos
            );
            antNP.mascotas = antNP.mascotas ? antNP.mascotas.id : "";
            antNP.viveCon = antNP.viveCon ? antNP.viveCon.id : "";
            antNP.servicios = antNP.servicios ? antNP.servicios : "";
            antNP.tipoPiso = antNP.tipoPiso ? antNP.tipoPiso : "";
            setAntecedentesNP(antNP);

            //padActual
            let padActual = Object.assign(
              {},
              response.data.data.padecimientoActual
            );
            padActual.fechaHora = padActual.fechaHora
              ? new Date(moment(padActual.fechaHora, "DD-MM-YYYY HH:mm"))
              : null;
            padActual.estatura = padActual.estatura ? padActual.estatura : "";
            padActual.frecuenciaCardiaca = padActual.frecuenciaCardiaca
              ? padActual.frecuenciaCardiaca
              : "";
            padActual.frecuenciaRespiratoria = padActual.frecuenciaRespiratoria
              ? padActual.frecuenciaRespiratoria
              : "";
            padActual.frecuenciaSaturacionOxigeno =
              padActual.frecuenciaSaturacionOxigeno
                ? padActual.frecuenciaSaturacionOxigeno
                : "";
            padActual.glasgow = padActual.glasgow ? padActual.glasgow : "";
            padActual.glucosaEnSangre = padActual.glucosaEnSangre
              ? padActual.glucosaEnSangre
              : "";
            padActual.indiceMasaCorporal =
              padActual.indiceMasaCorporal !== null
                ? padActual.indiceMasaCorporal
                : "";
            padActual.perimetroCefalico = padActual.perimetroCefalico
              ? padActual.perimetroCefalico
              : "";
            padActual.peso = padActual.peso ? padActual.peso : "";
            padActual.presionDiastolica = padActual.presionDiastolica
              ? padActual.presionDiastolica
              : "";
            padActual.presionSistolica = padActual.presionSistolica
              ? padActual.presionSistolica
              : "";
            padActual.temperatura = padActual.temperatura
              ? padActual.temperatura
              : "";
            padActual.tipoMedicion = padActual.tipoMedicion
              ? padActual.tipoMedicion
              : "";
            padActual.numeroTirasControlUtilizadas = padActual.numeroTirasControlUtilizadas
              ? padActual.numeroTirasControlUtilizadas
              : "";
            padActual.relacionTemporal = padActual.relacionTemporal
              ? padActual.relacionTemporal
              : "";
            padActual.circunferenciaCintura = padActual.circunferenciaCintura
              ? padActual.circunferenciaCintura
              : "";
            padActual.primeraVezAnio = padActual.primeraVezAnio || "";
            padActual.primeraVezUnemeSaih = padActual.primeraVezUnemeSaih || "";
            padActual.tipoDificultad = padActual.tipoDificultad || "";
            padActual.gradoDificultad = padActual.gradoDificultad || "";
            padActual.origenDificultad = padActual.origenDificultad || "";
            //console.log(padActual)
            setPadecimientoActual(padActual);
          }
          setReload(false);
        })
        .catch((error) => {
          setShowModalServer(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
    }
  }, [reload]);

  const handleClose = () => setShowModal(false);

  const plusNewRowAHF = () => {
    let newObj = {
      id: null,
      tipoFamiliar: "",
      diabetes: "NO",
      hipertension: "NO",
      congenitos: "NO",
      cardiologicos: "NO",
      neurologicos: "NO",
      vivo: "SI",
    };
    let arr = [...antecedentesHF, newObj];
    setAntecedentesHF(arr);
  };

  const deleteAHF = (elemento, idx) => {
    let arr = [...antecedentesHF];
    arr.splice(idx, 1);
    setAntecedentesHF(arr);
  };

  const changeAHF = (type, index, value) => {
    let arr = [...antecedentesHF];
    arr[index][type] = value;
    setAntecedentesHF(arr);
  };

  const changeANP = (type, value) => {
    let newObj = Object.assign({}, antecedentesNP);
    newObj[type] = value;
    setAntecedentesNP(newObj);
  };

  const changeAP = (type, index, value) => {
    let arr = [...antecedentesPatologicos];
    arr[index][type] = value;
    setAntecedentesPatologicos(arr);
  };

  const plusNewRowAP = () => {
    let newObj = {
      id: null,
      enfermedad: "",
      anios: "",
      meses: "",
      observaciones: "",
      presentaPadecimiento: "SI",
      tratamiento: "",
    };
    let arr = [...antecedentesPatologicos, newObj];
    setAntecedentesPatologicos(arr);
  };

  const deleteAP = (elemento, idx) => {
    let arr = [...antecedentesPatologicos];
    arr.splice(idx, 1);
    setAntecedentesPatologicos(arr);
  };

  const changePA = (type, value) => {
    let newObj = Object.assign({}, padecimientoActual);
    newObj[type] = value;
    setPadecimientoActual(newObj);
  };
  //campos a validar
  const fieldsToValidate = {
    circunferenciaCintura: {
      value: padecimientoActual.circunferenciaCintura,
      rule: value => value === 0 || (value >= 20 && value <= 300),
      message: "El valor debe de ser entre 20 y 300."
    },
    // Add more fields here...
  };
  //funcion de validación
  function validateField(fieldName, value, rule, message) {
    if (rule(value)) {
      setErrors(prevErrors => ({ ...prevErrors, [fieldName]: "" }));
      return true;
    } else {
      setErrors(prevErrors => ({ ...prevErrors, [fieldName]: message }));
      return false;
    }
  }

  const saveExpedienteClinico = () => {
    //change formato de fecha en PA

    let antHF = validateAHF(antecedentesHF);
    let antNP = validateANP(antecedentesNP);
    let antP = validateAP(antecedentesPatologicos);
    let pA = validatePA(padecimientoActual);

    let data = {
      id: id,
      appointment: { id: cita.id },
      antecedentesFamiliares: antHF,
      antecedentesNoPatologicos: antNP,
      antecedentesPatologicos: antP,
      padecimientoActual: pA,
    };

    //console.log(data)
    //validation

    // Iterate over the fields to validate
    let allValid = true;
    for (const [fieldName, { value, rule, message }] of Object.entries(fieldsToValidate)) {
      if (!validateField(fieldName, value, rule, message)) {
        allValid = false;
      }
    }

    if (!allValid) {
      return
    }

    setSubmiting(true);

    if (id) {
      Put({
        url: UPDATE_EXPEDIENTE_CLINICO,
        data: data,
        access_token: auth.data.access_token,
        header: true,
      })
        .then((response) => {
          //console.log(response)
          setSubmiting(false);
          setReload(true);
          setShowSuccess(true);
          setTimeout(() => {
            setShowSuccess(false);
          }, 2000);
        })
        .catch((error) => {
          setSubmiting(false);
          setShowModalServer(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
    } else {
      Post({
        url: SAVE_EXPEDIENTE_CLINICO,
        data: data,
        access_token: auth.data.access_token,
        header: true,
      })
        .then((response) => {
          setSubmiting(false);
          setReload(true);
          setShowSuccess(true);
          setTimeout(() => {
            setShowSuccess(false);
          }, 2000);
        })
        .catch((error) => {
          setSubmiting(false);
          setShowModalServer(true);
          if (error.response) {
            setErrorServer(error.response);
          }
        });
    }
  };

  const validateAHF = (antHF) => {
    let arr = [];
    antHF.forEach((item) => {
      let obj = Object.assign({}, item);
      obj.tipoFamiliar =
        obj.tipoFamilia !== "" ? { id: obj.tipoFamiliar } : null;
      arr.push(obj);
    });
    return arr;
  };
  const validateANP = (antNP) => {
    let obj = Object.assign({}, antNP);
    obj.servicios = obj.servicios !== "" ? obj.servicios : null;
    obj.tipoPiso = obj.tipoPiso !== "" ? obj.tipoPiso : null;
    obj.mascotas = obj.mascotas !== "" ? { id: obj.mascotas } : null;
    obj.viveCon = obj.viveCon !== "" ? { id: obj.viveCon } : null;
    return obj;
  };
  const validateAP = (antP) => {
    let arr = [];
    antP.forEach((item) => {
      let obj = Object.assign({}, item);
      obj.enfermedad = obj.enfermedad !== "" ? { id: obj.enfermedad } : null;
      arr.push(obj);
    });
    return arr;
  };

  const validatePA = (pA) => {
    let objPA = Object.assign({}, pA);
    objPA.fechaHora = objPA.fechaHora
      ? moment(objPA.fechaHora).format("DD/MM/YYYY HH:mm:ss")
      : null;
    return objPA;
  };

  const [typeReport, setTypeReport] = useState("");
  const [dataReport, setDataReport] = useState([]);
  const [showModalReport, setShowModalReport] = useState(false);
  const handleCloseReport = () => setShowModalReport(false);
  const getReport = (type) => {
    let str = getTypeReport(type);
    setTypeReport(str);
    let url = `${REPORT_HISTORIC_DATA}/0/9999/id/desc/${cita.patientDTO.id}?indicadorExpediente=${type}`;
    Get({ url: url, access_token: auth.data.access_token })
      .then((response) => {
        //console.log(response)
        if (Object.keys(response.data.data.response).length > 0) {
          //console.log(Object.keys(response.data.data.response))
          let arr = [];
          Object.keys(response.data.data.response).forEach((elem) => {
            let obj = {
              time: elem,
              valor: response.data.data.response[elem],
            };
            arr.push(obj);
          });
          //console.log(arr)
          setDataReport(arr);
          setShowModalReport(true);
        } else {
          setDataReport([]);
          setShowModalReport(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getTypeReport = (type) => {
    let obj = {
      peso: "Peso (kg)",
      frecuenciaCardiaca: "F.Cardíaca (lat/min)",
      frecuenciaSaturacionOxigeno: "Saturación O2(%)",
      perimetroCefalico: "Perim. Cefálico (cm)",
      estatura: "Talla (m)",
      presionSistolica: "Pres. Sistólica (mmHg)",
    };

    return obj[type] || "";
  };

  const [typeHistoric, setTypeHistory] = useState(null);
  const [dataHistoricEC, setDataHistoricEC] = useState(null);
  const [dataHistoricMEC, setDataHistoricMEC] = useState(null);
  const [dataHistoricLEC, setDataHistoricLEC] = useState(null);
  const getHistoric = (type) => {
    //console.log(type)
    let objUrl = {
      antecedentesPF: `${RESPORT_HISTORIC_EXP}/0/5/id/desc/${cita.patientDTO.id}`,
      resultadoLab: `${REPORT_DOCUMENT_PATIENT}/0/5/id/desc/${cita.patientDTO.id}`,
      medicamentosUsados: `${REPORT_MEDICAMENTOS}/0/5/id/desc/${cita.patientDTO.id}`,
    };
    let url = objUrl[type];
    Get({ url: url, access_token: auth.data.access_token })
      .then((response) => {
        //console.log(response)
        if (type === "antecedentesPF") {
          setDataHistoricEC(response.data.data.response.content);
        } else if (type === "medicamentosUsados") {
          setDataHistoricMEC(response.data.data.response.content);
        } else {
          setDataHistoricLEC(response.data.data.response.content);
        }

        setTypeHistory(type);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const typeHistoricObj = {
    antecedentesPF: <HistoricExpC data={dataHistoricEC} />,
    resultadoLab: <HistoricExpCLab data={dataHistoricLEC} cita={cita} />,
    medicamentosUsados: <HistoricExpCMedicamentos data={dataHistoricMEC} />,
  };

  return (
    <>

      <div className="p-3 pt-4 position-relative">
        {!showModal && (
          <div
            className="cita-btn-add-container"
            onClick={(e) => setShowModal(true)}
          >
            <Button variant="outline-primary" type="button" size="sm">
              Expediente clínico
            </Button>{" "}
          </div>
        )}
      </div>
      <Modal show={showModal} onHide={handleClose} dialogClassName="modal-90w">
        {isSubmiting && <SimpleLoad />}
        <Modal.Header closeButton>
          <h6>Expediente clínico</h6>
        </Modal.Header>
        <Modal.Body>
          <Tabs
            id="uncontrolled-tab-example"
            className="mb-3"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab
              eventKey="antecedentesHF"
              title="Antecedentes heredofamiliares"
            >
              <Row className="mt-4">
                <Col xs="12" md="12" className="mb-2">
                  {!readOnly && (
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={plusNewRowAHF}
                    >
                      <FaPlus /> Nuevo
                    </Button>
                  )}
                </Col>
                <Col xs="12" md="12">
                  <Table size="sm" className="table-ahf font-size-08rem">
                    <thead>
                      <tr>
                        <th>Familiar</th>
                        <th>Diabetes</th>
                        <th>Hipertensión</th>
                        <th>Congénitos</th>
                        <th>Cardiológicos</th>
                        <th>Neurológicos</th>
                        <th>Vivo</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {antecedentesHF.map((ahf, i) => (
                        <tr key={i}>
                          <td width="30%">
                            <select
                              className="input-table"
                              value={ahf.tipoFamiliar}
                              onChange={(e) =>
                                changeAHF("tipoFamiliar", i, e.target.value)
                              }
                            >
                              <option value="">Seleccionar</option>
                              {tipoFamiliarOpt.map((item, i) => (
                                <option key={i} value={item.id}>
                                  {item.nombreTipoFamiliar}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td width="10%">
                            <select
                              className="input-table"
                              value={ahf.diabetes}
                              onChange={(e) =>
                                changeAHF("diabetes", i, e.target.value)
                              }
                            >
                              <option value="SI">SI</option>
                              <option value="NO">NO</option>
                            </select>
                          </td>
                          <td width="10%">
                            <select
                              className="input-table"
                              value={ahf.hipertension}
                              onChange={(e) =>
                                changeAHF("hipertension", i, e.target.value)
                              }
                            >
                              <option value="SI">SI</option>
                              <option value="NO">NO</option>
                            </select>
                          </td>
                          <td width="10%">
                            <select
                              className="input-table"
                              value={ahf.congenitos}
                              onChange={(e) =>
                                changeAHF("congenitos", i, e.target.value)
                              }
                            >
                              <option value="SI">SI</option>
                              <option value="NO">NO</option>
                            </select>
                          </td>
                          <td width="10%">
                            <select
                              className="input-table"
                              value={ahf.cardiologicos}
                              onChange={(e) =>
                                changeAHF("cardiologicos", i, e.target.value)
                              }
                            >
                              <option value="SI">SI</option>
                              <option value="NO">NO</option>
                            </select>
                          </td>
                          <td width="10%">
                            <select
                              className="input-table"
                              value={ahf.neurologicos}
                              onChange={(e) =>
                                changeAHF("neurologicos", i, e.target.value)
                              }
                            >
                              <option value="SI">SI</option>
                              <option value="NO">NO</option>
                            </select>
                          </td>
                          <td width="10%">
                            <select
                              className="input-table"
                              value={ahf.vivo}
                              onChange={(e) =>
                                changeAHF("vivo", i, e.target.value)
                              }
                            >
                              <option value="SI">SI</option>
                              <option value="NO">NO</option>
                            </select>
                          </td>
                          <td width="10%" className="text-center">
                            {!readOnly && (
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={(e) => deleteAHF(ahf, i)}
                              >
                                <FaTimes />
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="antecedentesNP" title="Antecedentes no patológicos">
              <dl className="row mt-4">
                <dt className="col-sm-3">Vive con</dt>
                <dd className="col-sm-9">
                  <select
                    className="input-table"
                    value={antecedentesNP.viveCon}
                    onChange={(e) => changeANP("viveCon", e.target.value)}
                  >
                    <option value="">Seleccionar</option>
                    {familiarOpt.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.nombreFamiliar}
                      </option>
                    ))}
                  </select>
                </dd>
                <dt className="col-sm-3">Mascotas</dt>
                <dd className="col-sm-9">
                  <select
                    className="input-table"
                    value={antecedentesNP.mascotas}
                    onChange={(e) => changeANP("mascotas", e.target.value)}
                  >
                    <option value="">Seleccionar</option>
                    {mascotasOpt.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.nombreMascota}
                      </option>
                    ))}
                  </select>
                </dd>
                <dt className="col-sm-3">Cuenta con servicios básicos</dt>
                <dd className="col-sm-9">
                  <select
                    className="input-table"
                    value={antecedentesNP.servicios}
                    onChange={(e) => changeANP("servicios", e.target.value)}
                  >
                    <option value="">Seleccionar</option>
                    <option value="Agua">Agua</option>
                    <option value="Luz">Luz</option>
                    <option value="Gas">Gas</option>
                    <option value="AguaLuzGas">Agua, Luz, Gas</option>
                  </select>
                </dd>

                <dt className="col-sm-3">Tipo piso</dt>
                <dd className="col-sm-9">
                  <select
                    className="input-table"
                    value={antecedentesNP.tipoPiso}
                    onChange={(e) => changeANP("tipoPiso", e.target.value)}
                  >
                    <option value="">Seleccionar</option>
                    <option value="Cemento">Cemento</option>
                    <option value="Tierra">Tierra</option>
                  </select>
                </dd>
              </dl>
            </Tab>
            <Tab eventKey="antecedentesP" title="Antecedentes patológicos">
              <Row className="mt-4">
                <Col xs="12" md="12" className="mb-2">
                  {!readOnly && (
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={plusNewRowAP}
                    >
                      <FaPlus /> Nuevo
                    </Button>
                  )}
                </Col>
                <Col xs="12" md="12">
                  <Table size="sm" className="table-ahf font-size-08rem">
                    <thead>
                      <tr>
                        <th>Enfermedad</th>
                        <th>Pres. padecimiento</th>
                        <th>Años</th>
                        <th>Meses</th>
                        <th>Tratamiento</th>
                        <th>Observaciones</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {antecedentesPatologicos.map((ap, i) => (
                        <tr key={i}>
                          <td width="20%">
                            <select
                              className="input-table"
                              value={ap.enfermedad}
                              onChange={(e) =>
                                changeAP("enfermedad", i, e.target.value)
                              }
                            >
                              <option value="">Seleccionar</option>
                              {enfermedadOpt.map((item, i) => (
                                <option key={i} value={item.id}>
                                  {item.nombreEnfermedad}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td width="10%">
                            <select
                              className="input-table"
                              value={ap.presentaPadecimiento}
                              onChange={(e) =>
                                changeAP(
                                  "presentaPadecimiento",
                                  i,
                                  e.target.value
                                )
                              }
                            >
                              <option value="SI">SI</option>
                              <option value="NO">NO</option>
                            </select>
                          </td>
                          <td width="10%">
                            <input
                              value={ap.anios}
                              onChange={(e) => {
                                const re = /^(0?[0-9]|[1-9][0-9])$/;
                                if (
                                  e.target.value === "" ||
                                  re.test(e.target.value)
                                ) {
                                  changeAP("anios", i, e.target.value);
                                }
                              }}
                              className="input-table"
                              type="text"
                              min="0"
                              max="99"
                            />
                          </td>
                          <td width="10%">
                            <input
                              value={ap.meses}
                              onChange={(e) => {
                                const re = /^([1-9]|10|11)$/;
                                if (
                                  e.target.value === "" ||
                                  re.test(e.target.value)
                                ) {
                                  changeAP("meses", i, e.target.value);
                                }
                              }}
                              className="input-table"
                              type="text"
                              min="1"
                              max="11"
                            />
                          </td>
                          <td width="20%">
                            <input
                              value={ap.tratamiento}
                              onChange={(e) =>
                                changeAP("tratamiento", i, e.target.value)
                              }
                              className="input-table"
                            />
                          </td>
                          <td width="25%">
                            <input
                              value={ap.observaciones}
                              onChange={(e) =>
                                changeAP("observaciones", i, e.target.value)
                              }
                              className="input-table"
                            />
                          </td>
                          <td width="5%" className="text-center">
                            {!readOnly && (
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={(e) => deleteAP(ap, i)}
                              >
                                <FaTimes />
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="padecimientoActual" title="Padecimiento actual">
              <Row className="mt-4">
                <Col xs="12" md="6">
                  <dl className="row">
                    <dt className="col-sm-5">Fecha y hora</dt>
                    <dd className="col-sm-7">
                      <DatePicker
                        selected={padecimientoActual.fechaHora}
                        onChange={(date) => changePA("fechaHora", date)}
                        className="input-table"
                        dateFormat="dd/MM/yyyy HH:mm"
                        showTimeInput
                        timeInputLabel="Hora:"
                      />
                    </dd>

                    <dt className="col-sm-5">¿Es la primera consulta en el año?</dt>
                    <dd className="col-sm-7">
                      <FormControl
                        as="select"
                        className="input-table"
                        name="primeraVezAnio"
                        value={padecimientoActual.primeraVezAnio}
                        onChange={(e) => {
                          changePA("primeraVezAnio", e.target.value);
                        }}
                      >
                        <option value="0">NO</option>
                        <option value="1">SI</option>
                      </FormControl>
                    </dd>
                    {padecimientoActual.primeraVezAnio == '1' && (
                      <>
                        <dt className="col-sm-5">¿Primera vez en un mes?</dt>
                        <dd className="col-sm-7">
                          <FormControl
                            as="select"
                            className="input-table"
                            name="primeraVezUnemeSaih"
                            value={padecimientoActual.primeraVezUnemeSaih}
                            onChange={(e) => {
                              changePA("primeraVezUnemeSaih", e.target.value);
                            }}
                          >
                            <option value="0">NO</option>
                            <option value="1">SI</option>
                          </FormControl>
                        </dd>
                        <dt className="col-sm-5">Tipo de Dificultad</dt>
                        <dd className="col-sm-7">
                          <FormControl
                            as="select"
                            className="input-table"
                            name="tipoDificultad"
                            value={padecimientoActual.tipoDificultad}
                            onChange={(e) => {
                              changePA("tipoDificultad", e.target.value);
                            }}
                          >
                            <option value="1">VER</option>
                            <option value="2">ESCUCHAR</option>
                            <option value="3">CAMINAR</option>
                            <option value="4">USAR BRAZOS / MANOS</option>
                            <option value="5">APRENDER / RECORDAR</option>
                            <option value="6">CUIDADO PERSONAL</option>
                            <option value="7">HABLAR / COMUNICARSE</option>
                            <option value="8">EMOCIONAL / MENTAL</option>
                            <option value="9">NINGUNA</option>
                          </FormControl>
                        </dd>
                        {padecimientoActual.tipoDificultad !== '-1' && (
                          <>
                            <dt className="col-sm-5">Tipo de Dificultad</dt>
                            <dd className="col-sm-7">
                              <FormControl
                                as="select"
                                className="input-table"
                                name="gradoDificultad"
                                value={padecimientoActual.gradoDificultad}
                                onChange={(e) => {
                                  changePA("gradoDificultad", e.target.value);
                                }}
                              >
                                <option value="1">POCA DIFICULTAD</option>
                                <option value="2">MUCHA DIFICULTAD</option>
                                <option value="3">NO PUEDE HACERLO</option>
                                <option value="9">SIN DIFICULTAD</option>
                              </FormControl>
                            </dd>

                            <dt className="col-sm-5">Origen de la Dificultad</dt>
                            <dd className="col-sm-7">
                              <FormControl
                                as="select"
                                className="input-table"
                                name="origenDificultad"
                                value={padecimientoActual.origenDificultad}
                                onChange={(e) => {
                                  changePA("origenDificultad", e.target.value);
                                }}
                              >
                                <option value="1">ENFERMEDAD</option>
                                <option value="2">EDAD AVANZADA</option>
                                <option value="3">NACIÓ ASÍ</option>
                                <option value="4">ACCIDENTE</option>
                                <option value="5">VIOLENCIA</option>
                                <option value="6">OTRA CAUSA</option>
                                <option value="9">SIN DIFICULTAD</option>
                              </FormControl>
                            </dd>
                          </>
                        )}
                      </>
                    )}

                    <dt className="col-sm-5">Temp.(C)</dt>
                    <dd className="col-sm-7">
                      <input
                        value={padecimientoActual.temperatura}
                        onChange={(e) => {
                          const re = /^\d+([.]\d{0,2})?$/;
                          if (
                            e.target.value === "" ||
                            re.test(e.target.value)
                          ) {
                            changePA("temperatura", e.target.value);
                          }
                        }}
                        className="input-table"
                        type="text"
                      />
                    </dd>
                    <dt className="col-sm-5">F.Cardíaca (lat/min)</dt>
                    <dd className="col-sm-7">
                      <InputGroup>
                        <FormControl
                          className="input-table"
                          value={padecimientoActual.frecuenciaCardiaca}
                          type="text"
                          onChange={(e) => {
                            const re = /^\d+([.]\d{0,2})?$/;
                            if (
                              e.target.value === "" ||
                              re.test(e.target.value)
                            ) {
                              changePA("frecuenciaCardiaca", e.target.value);
                            }
                          }}
                        />
                        <Button
                          variant="outline-secondary"
                          className="btn-input-table"
                          onClick={(e) => getReport("frecuenciaCardiaca")}
                        >
                          <IoMdStats />
                        </Button>
                      </InputGroup>
                    </dd>

                    <dt className="col-sm-5">F.Respiratoria (resp/min)</dt>
                    <dd className="col-sm-7">
                      <input
                        value={padecimientoActual.frecuenciaRespiratoria}
                        type="text"
                        onChange={(e) => {
                          const re = /^\d+([.]\d{0,2})?$/;
                          if (
                            e.target.value === "" ||
                            re.test(e.target.value)
                          ) {
                            changePA("frecuenciaRespiratoria", e.target.value);
                          }
                        }}
                        className="input-table"
                      />
                    </dd>

                    <dt className="col-sm-5">Saturación O2(%)</dt>
                    <dd className="col-sm-7">
                      <InputGroup>
                        <FormControl
                          className="input-table"
                          value={padecimientoActual.frecuenciaSaturacionOxigeno}
                          type="text"
                          onChange={(e) => {
                            const re = /^\d+([.]\d{0,2})?$/;
                            if (
                              e.target.value === "" ||
                              re.test(e.target.value)
                            ) {
                              changePA(
                                "frecuenciaSaturacionOxigeno",
                                e.target.value
                              );
                            }
                          }}
                        />
                        <Button
                          variant="outline-secondary"
                          className="btn-input-table"
                          onClick={(e) =>
                            getReport("frecuenciaSaturacionOxigeno")
                          }
                        >
                          <IoMdStats />
                        </Button>
                      </InputGroup>
                    </dd>
                    <dt className="col-sm-5">Perim. Cefálico (cm)</dt>
                    <dd className="col-sm-7">
                      <InputGroup>
                        <FormControl
                          className="input-table"
                          value={padecimientoActual.perimetroCefalico}
                          type="text"
                          onChange={(e) => {
                            const re = /^\d+([.]\d{0,2})?$/;
                            if (
                              e.target.value === "" ||
                              re.test(e.target.value)
                            ) {
                              changePA("perimetroCefalico", e.target.value);
                            }
                          }}
                        />
                        <Button
                          variant="outline-secondary"
                          className="btn-input-table"
                          onClick={(e) => getReport("perimetroCefalico")}
                        >
                          <IoMdStats />
                        </Button>
                      </InputGroup>
                    </dd>

                    <dt className="col-sm-5">Peso (kg)</dt>
                    <dd className="col-sm-7">
                      <InputGroup>
                        <FormControl
                          className="input-table"
                          value={padecimientoActual.peso}
                          type="text"
                          onChange={(e) => {
                            const re = /^\d+([.]\d{0,2})?$/;
                            if (
                              e.target.value === "" ||
                              re.test(e.target.value)
                            ) {
                              changePA("peso", e.target.value);
                            }
                          }}
                        />
                        <Button
                          variant="outline-secondary"
                          className="btn-input-table"
                          onClick={(e) => getReport("peso")}
                        >
                          <IoMdStats />
                        </Button>
                      </InputGroup>
                    </dd>

                    <dt className="col-sm-5">Circunferencia Cintura (cm)</dt>
                    <dd className="col-sm-7">
                      <InputGroup>
                        <FormControl
                          className={"input-table" + (errors.circunferenciaCintura ? " error" : "")}
                          value={padecimientoActual.circunferenciaCintura}
                          type="text"
                          onChange={(e) => {
                            const re = /^\d+([.]\d{0,2})?$/;
                            const value = Number(e.target.value);
                            if (
                              e.target.value === "" || (re.test(e.target.value))
                            ) {
                              changePA("circunferenciaCintura", e.target.value);
                            }
                          }}
                        />
                        <Button
                          variant="outline-secondary"
                          className="btn-input-table"
                          onClick={(e) => getReport("circunferenciaCintura")}
                        >
                          <IoMdStats />
                        </Button>
                      </InputGroup>
                      {errors.circunferenciaCintura && <div className="error-message invalid-feedback d-block">{errors.circunferenciaCintura}</div>}
                    </dd>

                    <dt className="col-sm-5">Talla (m)</dt>
                    <dd className="col-sm-7">
                      <InputGroup>
                        <FormControl
                          className="input-table"
                          value={padecimientoActual.estatura}
                          type="text"
                          onChange={(e) => {
                            const re = /^\d+([.]\d{0,2})?$/;
                            if (
                              e.target.value === "" ||
                              re.test(e.target.value)
                            ) {
                              changePA("estatura", e.target.value);
                            }
                          }}
                        />
                        <Button
                          variant="outline-secondary"
                          className="btn-input-table"
                          onClick={(e) => getReport("estatura")}
                        >
                          <IoMdStats />
                        </Button>
                      </InputGroup>
                    </dd>
                  </dl>
                </Col>
                <Col xs="12" md="6">
                  <dl className="row">
                    <dt className="col-sm-5">Indice de masa corporal(IMC)</dt>
                    <dd className="col-sm-7">
                      <InputGroup>
                        <FormControl
                          className="input-table"
                          value={padecimientoActual.indiceMasaCorporal}
                          type="text"
                          onChange={(e) => {
                            const re = /^\d+([.]\d{0,2})?$/;
                            if (
                              e.target.value === "" ||
                              re.test(e.target.value)
                            ) {
                              changePA("indiceMasaCorporal", e.target.value);
                            }
                          }}
                        />
                        <Button
                          variant="outline-secondary"
                          className="btn-input-table"
                          onClick={(e) => getReport("indiceMasaCorporal")}
                        >
                          <IoMdStats />
                        </Button>
                      </InputGroup>
                    </dd>

                    <dt className="col-sm-5">Glucosa en sangre (mg/dL)</dt>
                    <dd className="col-sm-7">
                      <input
                        value={padecimientoActual.glucosaEnSangre}
                        type="text"
                        onChange={(e) => {
                          const re = /^\d+([.]\d{0,2})?$/;
                          if (
                            e.target.value === "" ||
                            re.test(e.target.value)
                          ) {
                            changePA("glucosaEnSangre", e.target.value);
                          }
                        }}
                        className="input-table"
                      />
                    </dd>

                    <dt className="col-sm-5">Tipo Medición</dt>
                    <dd className="col-sm-7">
                      <select
                        value={padecimientoActual.tipoMedicion}
                        onChange={(e) => {
                          changePA("tipoMedicion", e.target.value);
                        }}
                        className="input-table"
                      >
                        {padecimientoActual.glucosaEnSangre == 0 || padecimientoActual.glucosaEnSangre === '' ? (
                          <option value="0">No aplica</option>
                        ) : (
                          <>
                            <option value="1">No</option>
                            <option value="2">Si</option>
                          </>
                        )}
                      </select>
                    </dd>

                    <dt className="col-sm-5">Tiras de Control</dt>
                    <dd className="col-sm-7">
                      <select
                        value={padecimientoActual.numeroTirasControlUtilizadas}
                        onChange={(e) => {
                          changePA("numeroTirasControlUtilizadas", e.target.value);
                        }}
                        className="input-table"
                      >
                        {padecimientoActual.glucosaEnSangre == 0 || padecimientoActual.glucosaEnSangre === '' ? (
                          <option value="0">0</option>
                        ) : (
                          <>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                          </>
                        )}
                      </select>
                    </dd>

                    <dt className="col-sm-5">Relación Temporal</dt>
                    <dd className="col-sm-7">
                      <select
                        value={padecimientoActual.relacionTemporal}
                        onChange={(e) => {
                          changePA("relacionTemporal", e.target.value);
                        }}
                        className="input-table"
                      >
                        <option value="0">Primera Vez</option>
                        <option value="1">Subsecuente</option>

                      </select>
                    </dd>

                    <dt className="col-sm-5">Pres. Sistólica (mmHg)</dt>
                    <dd className="col-sm-7">
                      <InputGroup>
                        <FormControl
                          className="input-table"
                          value={padecimientoActual.presionSistolica}
                          type="text"
                          onChange={(e) => {
                            const re = /^\d+([.]\d{0,2})?$/;
                            if (
                              e.target.value === "" ||
                              re.test(e.target.value)
                            ) {
                              changePA("presionSistolica", e.target.value);
                            }
                          }}
                        />
                        <Button
                          variant="outline-secondary"
                          className="btn-input-table"
                          onClick={(e) => getReport("presionSistolica")}
                        >
                          <IoMdStats />
                        </Button>
                      </InputGroup>
                    </dd>

                    <dt className="col-sm-5">Pres. Diastólica (mmHg)</dt>
                    <dd className="col-sm-7">
                      <input
                        value={padecimientoActual.presionDiastolica}
                        type="text"
                        onChange={(e) => {
                          const re = /^\d+([.]\d{0,2})?$/;
                          if (
                            e.target.value === "" ||
                            re.test(e.target.value)
                          ) {
                            changePA("presionDiastolica", e.target.value);
                          }
                        }}
                        className="input-table"
                      />
                    </dd>

                    <dt className="col-sm-5">Glasgow</dt>
                    <dd className="col-sm-7">
                      <input
                        value={padecimientoActual.glasgow}
                        type="text"
                        onChange={(e) => {
                          const re = /^\d+([.]\d{0,2})?$/;
                          if (
                            e.target.value === "" ||
                            re.test(e.target.value)
                          ) {
                            changePA("glasgow", e.target.value);
                          }
                        }}
                        className="input-table"
                      />
                    </dd>
                  </dl>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="historiales" title="Historiales">
              <Row className="mt-5">
                <Col xs="12" md="12">
                  <ul className="list-inline">
                    <li className="list-inline-item">
                      <Button
                        type="button"
                        variant="outline-secondary"
                        onClick={(e) => getHistoric("antecedentesPF")}
                      >
                        Antecedentes personales y familiares
                      </Button>
                    </li>
                    <li className="list-inline-item">
                      <Button
                        type="button"
                        variant="outline-secondary"
                        onClick={(e) => getHistoric("resultadoLab")}
                      >
                        Resultados de laboratorios
                      </Button>
                    </li>
                    <li className="list-inline-item">
                      <Button
                        type="button"
                        variant="outline-secondary"
                        onClick={(e) => getHistoric("medicamentosUsados")}
                      >
                        Medicamentos usados
                      </Button>
                    </li>
                  </ul>
                </Col>
                <Col xs="12" md="6"></Col>
              </Row>

              {typeHistoricObj[typeHistoric]}
            </Tab>

            <Tab eventKey="antperspatologicos" title="Ant. pers. patológicos">
              <AntPersPatologicos
                setShowModalServer={setShowModalServer}
                setErrorServer={setErrorServer}
                setShowSuccess={setShowSuccess}
                citaId={cita.id}
                pato={cita.atencionPatologicos ?? null}
              />
            </Tab>

            {((cita.patientDTO.ageDTO?.years ?? 0) > 9 || cita.patientDTO.ageDTO === undefined) &&
              (cita.patientDTO.gender === "Female" || cita.patientDTO.gender === undefined) && (
                <Tab eventKey="ginecoObstretico" title="GinecoObstétrico">
                  <GinecoObstetricoMex
                    setShowModalServer={setShowModalServer}
                    setErrorServer={setErrorServer}
                    setShowSuccess={setShowSuccess}
                    citaId={cita.id}
                    validationData={{
                      'gender': cita.patientDTO.gender || null,
                      'age': cita.patientDTO.ageDTO || null,
                      'speciality': cita.idSpeciality || null,
                      'claveTipoEstablecimiento': 1 /* 1 = Consulta externa */ || null,
                      'claveTipologia': '' || null,
                      'claveSubtipologia': 'UNE99' || null
                    }}
                    gineco={cita.ginecoObstetrico ?? null}
                  />
                </Tab>
              )}

            {(cita.patientDTO?.ageDTO?.years < 18 || cita.patientDTO?.ageDTO === undefined) && (
              <Tab eventKey="ninoSano" title="Atención Niño Sano">
                <HealthyChildMex
                  setShowModalServer={setShowModalServer}
                  setErrorServer={setErrorServer}
                  setShowSuccess={setShowSuccess}
                  citaId={cita.id}
                  child={cita.atencionNinoSano ?? null}
                  validationData={{
                    'age': cita.patientDTO.ageDTO || null,
                    'speciality': cita.idSpeciality || null,
                    'clues': cita.patientDTO.account.clues,
                  }}
                />
              </Tab>
            )}

            {(cita.patientDTO?.ageDTO?.years > 65 || cita.patientDTO?.ageDTO === undefined) && (
              <Tab eventKey="gerontological" title="Atención Gerontológica">
                <GerontologicalMex
                  setShowModalServer={setShowModalServer}
                  setErrorServer={setErrorServer}
                  setShowSuccess={setShowSuccess}
                  citaId={cita.id}
                  gerontological={cita.atencionGerontologica ?? null}
                  validationData={{
                    'age': cita.patientDTO.ageDTO || null,
                    'speciality': cita.idSpeciality || null,
                  }}
                />
              </Tab>
            )}

            <Tab eventKey="healthpromotion" title="Promoción de la salud">
              <HealthPromotion
                setShowModalServer={setShowModalServer}
                setErrorServer={setErrorServer}
                setShowSuccess={setShowSuccess}
                citaId={cita.id}
                promocionSalud={cita.promocionSalud ?? null}
                validationData={{
                  'age': cita.patientDTO.ageDTO || null,
                  'speciality': cita.idSpeciality || null,
                  'gender': cita.patientDTO.gender || null,
                  'relacionTemporalEmbarazo': cita.ginecoObstetrico ? cita.ginecoObstetrico.relacionTemporalEmbarazo : '-1',
                }}
              />
            </Tab>
            <Tab eventKey="accidentprevention" title="Prevención Accidentes">
              <AccidentPrevention
                setShowModalServer={setShowModalServer}
                setErrorServer={setErrorServer}
                setShowSuccess={setShowSuccess}
                citaId={cita.id}
                prevencionAccidentes={cita.prevencionAccidentes ?? null}
                validationData={{
                  'age': cita.patientDTO.ageDTO || null,
                  'speciality': cita.idSpeciality || null,
                }}
              />
            </Tab>
          </Tabs>
        </Modal.Body>
        {hideSaveDefault(key) && (
          <Modal.Footer>
            {!readOnly && (
              <Button
                variant="outline-success"
                className="ok-buttom"
                onClick={saveExpedienteClinico}
              >
                Guardar
              </Button>
            )}
          </Modal.Footer>
        )}
      </Modal>

      <Modal
        show={showModalReport}
        onHide={handleCloseReport}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <h3>{typeReport}</h3>
        </Modal.Header>
        <Modal.Body>
          <Table bordered size="sm">
            <thead>
              <tr>
                <th>Fecha de la cita</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              {dataReport.length > 0 ? (
                dataReport.map((item, i) => (
                  <tr key={i}>
                    <td>
                      {moment(item.time, "YYYY-MM-DDTHH:mm").format(
                        "DD-MM-YYYY HH:mm"
                      )}
                    </td>
                    <td>{item.valor}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2">No existe historial</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default withTranslation()(ExpedienteClinicoMex);
